import React from "react";
import PublicBookJournalCatalog from "../components/learner/PublicBookJournalCatalog";

/** Public book marketplace listing; authentication is required at checkout. */
const Books = () => <PublicBookJournalCatalog kind="book" />;

export default Books;
